// assets
import { ChromeOutlined, QuestionOutlined, TeamOutlined, ClockCircleOutlined } from '@ant-design/icons';

// icons
const icons = {
  ChromeOutlined,
  QuestionOutlined,
  TeamOutlined,
  ClockCircleOutlined
};

const support = {
  id: 'vendor',
  title: '',
  type: 'group',
  roles: ['vendor'], // Only vendors can see this group
  children: [
    {
      id: 'timetracking',
      title: 'Time Tracking',
      type: 'item',
      url: 'vendor/timetracking',
      icon: icons.ClockCircleOutlined,
      requiredFeature: 'time_tracking'
    },
    {
      id: 'invoices',
      title: 'Invoices',
      type: 'item',
      url: 'vendor/invoices',
      icon: icons.ChromeOutlined
    },
    {
      id: 'subcontractors',
      title: 'Subcontractors',
      type: 'item',
      url: 'vendor/subcontractors',
      icon: icons.TeamOutlined
    }
  ]
};

export default support;
